const DAYS_PER_400_YEARS = 146097;
const MONTHS_PER_400_YEARS = 4800;
/* Handles negative mod. Same as @eturi/util */
export const mod = (n, m) => ((n % m) + m) % m;
/** Converts days to months (avg over 400yr period) */
export const _d2M = (days) => (days * MONTHS_PER_400_YEARS) / DAYS_PER_400_YEARS;
/** Converts months to days (avg over 400yr period)*/
export const _M2d = (months) => (months * DAYS_PER_400_YEARS) / MONTHS_PER_400_YEARS;
//# sourceMappingURL=internal.js.map